/* eslint-disable @typescript-eslint/no-explicit-any */
import useSession from '@/hooks/useSession';
import { AuthoritiesType } from '@/types/Authority';
import Combos from '@/types/Combo';

export function hasComboPermissions(
  authorities?: AuthoritiesType[],
  some = false,
) {
  function useHook() {
    const session = useSession();
    if (session?.module && authorities) {
      if (some) {
        return authorities.some((authority: any) =>
          Combos[session.module].includes(authority),
        );
      }

      return authorities.every((authority: any) =>
        Combos[session.module].includes(authority),
      );
    }
    return false;
  }

  return useHook();
}
